<style lang="less">
@import "./login.less";
@import "./animate.min.css";

.forgot-password-btn {
  color: #ff6b6b !important;
  font-size: 14px;
  padding: 6px 12px;
  background: transparent !important;
  border: none !important;
  border-radius: 4px;
  transition: all 0.2s ease;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 1px;
    background: #ff6b6b;
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }

  &:hover {
    color: #ff5252 !important;
    background: rgba(255, 107, 107, 0.1) !important;

    &::after {
      width: 100%;
    }
  }

  &:active {
    color: #e53935 !important;
    transform: translateY(1px);
  }

  &:focus {
    color: #ff6b6b !important;
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 107, 107, 0.3);
  }
}

.login-btn {
  background: linear-gradient(135deg, #4a90e2 0%, #5ba3f5 50%, #4a90e2 100%) !important;
  border: 1px solid #4a90e2 !important;
  color: #ffffff !important;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.2);

  &:hover {
    background: linear-gradient(135deg, #5ba3f5 0%, #4a90e2 50%, #5ba3f5 100%) !important;
    border-color: #5ba3f5 !important;
    color: #ffffff !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 15px rgba(74, 144, 226, 0.3);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(74, 144, 226, 0.2);
  }

  &:focus {
    color: #ffffff !important;
    box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.3);
  }
}


</style>

<template>
  <div :class="loginClass">
    <!--<div class="modal"></div>-->
    <!--<div class="login-box">
      <Form ref="loginForm" :model="form" :rules="rules" style="width:100%;">
        <div style="padding-bottom:20px;padding-top:60px;">
          <span style="padding-left:30px;font-size:16px;">账号登录</span>
        </div>
        <FormItem prop="phone">
          <Input v-model.trim="form.phone" placeholder="请输入用户名">
            <span slot="prepend">
              <Icon type="md-contact" size="16"/>
            </span>
          </Input>
        </FormItem>
        <FormItem prop="cacheValue">
          <Input type="password" v-model.trim="form.cacheValue" placeholder="请输入密码">
            <span slot="prepend">
              <Icon type="md-lock" size="14"/>
            </span>
          </Input>
        </FormItem>
        <div style="padding-left: 20px;">
          <Button style="width:40%;" shape="circle" @click="handleSubmit" type="primary">登录</Button>
        </div>
      </Form>
    </div>-->
    <!--<div class="loading-login">
      <div class="loading-login-info animated fadeInLeft">
        <lottie :options="defaultOptions" :height="100" :width="200"/>
        <span>登录中</span>
      </div>
    </div>-->
    <Row>
      <h1 style="font-size: 100px;color: red">ROBOT</h1>
      <Form ref="loginForm" :model="form" :rules="rules" style="width:100%;">
        <FormItem prop="phone">
          <Input v-model.trim="form.phone" :placeholder="langMap.loginPlaceholder[lang]" size="large">
            <span slot="prepend">
              <Icon type="md-contact" size="16"/>
            </span>
          </Input>
        </FormItem>
        <FormItem prop="cacheValue">
          <Input type="password" v-model.trim="form.cacheValue" :placeholder="langMap.passwordPlaceholder[lang]" size="large" >
            <span slot="prepend">
              <Icon type="md-lock" size="14"/>
            </span>
          </Input>
        </FormItem>
        <div style="text-align: center;margin-bottom: 20px;margin-top: 40px">
          <Button
            :loading="loading"
            class="login-btn"
            style="width:100%;"
            shape="circle"
            @click="handleSubmit"
            size="large"
          >
            {{ langMap.loginButton[lang] }}
          </Button>
        </div>
        <div style="text-align: center;margin-bottom: 120px;">
          <Button
            type="text"
            @click="openForgotPasswordModal"
            class="forgot-password-btn"
          >
            {{langMap.forgotPassword[lang]}}
          </Button>
        </div>
      </Form>
    </Row>

    <!-- 忘记密码弹窗 -->
    <Modal
      :mask-closable="false"
      :title="langMap.resetPassword[lang]"
      v-model="forgotPasswordModal"
      width="500"
    >
      <Form
        ref="forgotPasswordForm"
        :model="forgotPasswordForm"
        :rules="forgotPasswordRules"
        :label-width="120"
      >
        <FormItem
          :label="langMap.accountOrPhone[lang] + ':'"
          prop="account"
          :error="accountError"
        >
          <Input
            type="text"
            v-model="forgotPasswordForm.account"
            :placeholder="langMap.pleaseInputAccountOrPhone[lang]"
            @on-blur="getEmailByAccount"
            @on-change="clearAccountError"
          />
        </FormItem>

        <FormItem
          :label="langMap.email[lang] + ':'"
          prop="email"
        >
          <Input
            type="email"
            v-model="forgotPasswordForm.email"
            :placeholder="langMap.email[lang]"
            :disabled="true"
            autocomplete="new-email"
          />
        </FormItem>

        <FormItem
          :label="langMap.verificationCode[lang] + ':'"
          prop="code"
        >
          <Input
            type="text"
            v-model="forgotPasswordForm.code"
            :placeholder="langMap.pleaseInputVerificationCode[lang]"
          >
            <Button
              slot="append"
              :loading="sendCodeLoading"
              :disabled="countdown > 0 || !forgotPasswordForm.email"
              @click="sendVerificationCode"
              type="primary"
            >
              <span v-if="countdown > 0">{{countdown}}{{langMap.resendAfterSeconds[lang]}}</span>
              <span v-else>{{langMap.sendVerificationCode[lang]}}</span>
            </Button>
          </Input>
        </FormItem>

        <FormItem
          :label="langMap.newPassword[lang] + ':'"
          prop="password"
        >
          <Input
            type="password"
            v-model="forgotPasswordForm.password"
            :placeholder="langMap.pleaseInputNewPassword[lang]"
            autocomplete="new-password"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="closeForgotPasswordModal" style="margin-left: 8px">{{langMap.cancel[lang]}}</Button>
        <Button @click="resetPassword" type="primary">{{langMap.resetPassword[lang]}}</Button>
      </div>
    </Modal>
    <!-- 备案信息组件 -->
    <FilingInfo />
  </div>
</template>

<script>
//加载组件
import Lottie from "vue-lottie";
import * as animationData from "./json/waiting.json";
//引入md5
var md5 = require("js-md5");
//引入api
import api from "../../api/index.js";
import { getTenantInfo } from "@/api/tenant";
import { setTenantId,setTenantInfo, clearLocalCache } from "@/libs/util";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import { validatePassword, createValidator } from '@/utils/validators';
import langmap from '@/utils/language'
export default {
  components: {
    Lottie,
    FilingInfo: () => import('@/components/filing-info/index.vue')
  },
  data() {
    return {
      langMap: langMap,
      //loading
      defaultOptions: {
        animationData: animationData.default
      },
      //登录动画
      loginClass: "des-login",
      form: {
        phone: "",
        password: "",
        cacheValue: ""
      },
      loading: false,

      // 忘记密码相关数据
      forgotPasswordModal: false,
      forgotPasswordForm: {
        account: "",
        email: "",
        code: "",
        password: ""
      },
      sendCodeLoading: false,
      countdown: 0,
      countdownTimer: null,
      accountError: "", // 账户输入框的错误信息



    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),

    // 登录表单验证规则
    rules() {
      return {
        phone: [
          {
            required: true,
            message: langMap.pleaseInputUsername[this.lang]
          }
        ],
        cacheValue: [
          {
            required: true,
            message: langMap.pleaseInputPassword[this.lang]
          }
        ]
      }
    },

    // 忘记密码表单验证规则
    forgotPasswordRules() {
      return {
        account: [
          {
            required: true,
            message: langMap.pleaseInputAccountOrPhone[this.lang]
          }
        ],
        email: [
          {
            required: true,
            message: langMap.pleaseInputEmail[this.lang]
          }
        ],
        code: [
          {
            required: true,
            message: langMap.pleaseInputVerificationCode[this.lang]
          }
        ],
        password: [
          {
            required: true,
            message: langMap.pleaseInputNewPassword[this.lang]
          },
          {
            validator: createValidator(validatePassword, this.lang)
          }
        ]
      }
    }
  },
  methods: {
    /**
     *登陆
     */
    handleSubmit() {
      // 检查屏幕分辨率
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;

      if (screenWidth < 1366) {
        this.$Notice.error({
          title: langMap.tips[this.lang],
          desc: langMap.screenResolutionError[this.lang].replace('${width}', screenWidth).replace('${height}', screenHeight)
        });
        return;
      }
      //md5加密密码
      this.$refs.loginForm.validate(valid => {
        if (valid && this.loginClass == "des-login") {
          var loginJson={
            pwd:md5(this.form.cacheValue),
            phone:this.form.phone
          }

          this.loading = true;

          // 先获取租户信息
          getTenantInfo(this.form.phone).then(tenantRes => {
            if (tenantRes.state == 0) {
              this.$Notice.error({
                title: "提示",
                desc: tenantRes.msg
              });
              this.loading = false;
              return;
            }
            // 设置租户ID
            setTenantId(tenantRes.data.id);
            // 存储完整的租户信息
            setTenantInfo(tenantRes.data);

            // 然后进行登录
            api.postData("system-server/login",loginJson, this).then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: "提示",
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.tip[this.lang],
                  desc: langMap.loginSuccess[this.lang]
                });
                //登录成功
                this.$store.commit('setToken', res.data);
                this.$router.push({
                  name: 'home'
                });
              }
              this.loading = false;
            });
          });
        }
      });
    },

    // 打开忘记密码弹窗
    openForgotPasswordModal() {
      this.forgotPasswordModal = true;
      this.resetForgotPasswordForm();
    },

    // 关闭忘记密码弹窗
    closeForgotPasswordModal() {
      this.forgotPasswordModal = false;
      this.resetForgotPasswordForm();
      this.clearCountdown();
    },

    // 重置忘记密码表单
    resetForgotPasswordForm() {
      this.forgotPasswordForm = {
        account: "",
        email: "",
        code: "",
        password: ""
      };
      this.accountError = ""; // 清除错误信息
      if (this.$refs.forgotPasswordForm) {
        this.$refs.forgotPasswordForm.resetFields();
      }
    },

    // 清除账户错误信息
    clearAccountError() {
      this.accountError = "";
    },

    // 根据账户获取邮箱
    getEmailByAccount() {
      if (!this.forgotPasswordForm.account) {
        this.accountError = "";
        this.forgotPasswordForm.email = "";
        return;
      }

      // 清除之前的错误信息
      this.accountError = "";

      api.postData("system-server/password/findEmail", {
        account: this.forgotPasswordForm.account
      }, this)
        .then(res => {
          if (res.state === 0) {
            this.accountError = res.msg || "获取邮箱失败";
            this.forgotPasswordForm.email = "";
          } else {
            this.accountError = "";
            this.forgotPasswordForm.email = res.data;
          }
        })
        .catch(() => {
          this.accountError = "获取邮箱失败";
          this.forgotPasswordForm.email = "";
        });
    },

    // 发送验证码
    sendVerificationCode() {
      if (!this.forgotPasswordForm.account) {
        this.$Notice.warning({
          title: langMap.tip[this.lang],
          desc: langMap.pleaseInputAccountOrPhone[this.lang]
        });
        return;
      }

      if (!this.forgotPasswordForm.email) {
        this.$Notice.warning({
          title: langMap.tip[this.lang],
          desc: "请先输入账户获取邮箱"
        });
        return;
      }

      this.sendCodeLoading = true;

      api.postData("system-server/password/sendCode", {
        account: this.forgotPasswordForm.account
      }, this).then(res => {
        this.sendCodeLoading = false;
        if (res.state === 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg || langMap.sendVerificationCodeFailed[this.lang]
          });
        } else {
          this.$Notice.success({
            title: langMap.tip[this.lang],
            desc: langMap.verificationCodeSent[this.lang]
          });
          this.startCountdown();
        }
      }).catch(() => {
        this.sendCodeLoading = false;
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: langMap.sendVerificationCodeFailed[this.lang]
        });
      });
    },

    // 开始倒计时
    startCountdown() {
      this.countdown = 60;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.clearCountdown();
        }
      }, 1000);
    },

    // 清除倒计时
    clearCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.countdown = 0;
    },



    // 重置密码
    resetPassword() {
      this.$refs.forgotPasswordForm.validate(valid => {
        if (valid) {
          const resetData = {
            account: this.forgotPasswordForm.account,
            code: this.forgotPasswordForm.code,
            password: md5(this.forgotPasswordForm.password)
          };

          this.$Spin.show();
          api.postData("system-server/password/reset", resetData, this)
            .then(res => {
              this.$Spin.hide();
              if (res.state === 0) {
                this.$Notice.error({
                  title: langMap.tip[this.lang],
                  desc: res.msg || langMap.resetPasswordFailed[this.lang]
                });
              } else {
                this.$Notice.success({
                  title: langMap.tip[this.lang],
                  desc: langMap.resetPasswordSuccess[this.lang]
                });
                this.closeForgotPasswordModal();
              }
            })
            .catch(() => {
              this.$Spin.hide();
              this.$Notice.error({
                title: langMap.tip[this.lang],
                desc: langMap.resetPasswordFailed[this.lang]
              });
            });
        }
      });
    }
  },
  created() {
    clearLocalCache();
    document.title = '（逻腾（杭州）科技有限公司）'
    // 监听回车事件
    document.onkeydown = (e) => {
      let _key = window.event.keyCode;
      if (_key === 13) {
        this.handleSubmit();
      }
    }
  },
  beforeDestroy() {
    document.onkeydown = null;
    this.clearCountdown();
  }
};
</script>
